/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  SmtpSettings,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    SmtpSettingsFromJSON,
    SmtpSettingsToJSON,
} from '../models';

export interface DeleteCustomerSmtpSettingsRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetCustomerSmtpSettingsRequest {
    xApplicationScope: ApplicationScope;
}

export interface TestCustomerSmtpSettingsRequest {
    xApplicationScope: ApplicationScope;
}

export interface UpdateCustomerSmtpSettingsRequest {
    xApplicationScope: ApplicationScope;
    smtpSettings: SmtpSettings;
}

/**
 * 
 */
export class SmtpControllerApi extends runtime.BaseAPI {

    /**
     * delete SMTP settings of current customer
     * delete SMTP settings of  current customer
     */
    async deleteCustomerSmtpSettingsRaw(requestParameters: DeleteCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmtpSettings>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteCustomerSmtpSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/smtp/current`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SmtpSettingsFromJSON(jsonValue));
    }

    /**
     * delete SMTP settings of current customer
     * delete SMTP settings of  current customer
     */
    async deleteCustomerSmtpSettings(requestParameters: DeleteCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmtpSettings> {
        const response = await this.deleteCustomerSmtpSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get SMTP settings of current customer
     * get SMTP settings of  current customer
     */
    async getCustomerSmtpSettingsRaw(requestParameters: GetCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmtpSettings>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCustomerSmtpSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/smtp/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SmtpSettingsFromJSON(jsonValue));
    }

    /**
     * get SMTP settings of current customer
     * get SMTP settings of  current customer
     */
    async getCustomerSmtpSettings(requestParameters: GetCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmtpSettings> {
        const response = await this.getCustomerSmtpSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * test SMTP settings of current customer
     * test SMTP settings of  current customer
     */
    async testCustomerSmtpSettingsRaw(requestParameters: TestCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling testCustomerSmtpSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/smtp/current/test`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * test SMTP settings of current customer
     * test SMTP settings of  current customer
     */
    async testCustomerSmtpSettings(requestParameters: TestCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.testCustomerSmtpSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * update SMTP settings of current customer
     * update SMTP settings of  current customer
     */
    async updateCustomerSmtpSettingsRaw(requestParameters: UpdateCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmtpSettings>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCustomerSmtpSettings.');
        }

        if (requestParameters.smtpSettings === null || requestParameters.smtpSettings === undefined) {
            throw new runtime.RequiredError('smtpSettings','Required parameter requestParameters.smtpSettings was null or undefined when calling updateCustomerSmtpSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/smtp/current`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SmtpSettingsToJSON(requestParameters.smtpSettings),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SmtpSettingsFromJSON(jsonValue));
    }

    /**
     * update SMTP settings of current customer
     * update SMTP settings of  current customer
     */
    async updateCustomerSmtpSettings(requestParameters: UpdateCustomerSmtpSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmtpSettings> {
        const response = await this.updateCustomerSmtpSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
